import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'servToStr'
})
export class ServToStrPipe implements PipeTransform {

  transform(value: any[]): string {
    if (!value || value.length === 0) {
      return '';
    }

    let result = '';
    const lastIndex = value.length - 1;

    value.forEach((item, index) => {
      if(item.service_name && item.service_name != 'null'){
        result += item.service_name;
        if (index !== lastIndex) {
          result += ', ';
        }

      }
    });
    
    return this.removeTrailingCommas(result);
  }

  removeTrailingCommas(input: string) {
    // Regular expression to remove trailing commas and optional spaces
    return input.replace(/,\s*$/, '');
  }
}
